import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "@websential/cosmic-v20";

import http from "../../common/http-commons";

export const DashboardServices = {
  getDashboardMenuData: async (
    clientId: string,
    taxYear: number,
  ): Promise<any | IServerError | IResponse> => {
    if (!clientId) return null;
    if (!taxYear) return null;
    try {
      const response: AxiosResponse = await http.get<any>(
        `/v1/dashboard/provinces-menu?client_id=${clientId}&tax_year=${taxYear}&status_code=all`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      } else {
        return response.data;
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      return {
        status: false,
        message: axiosError.response
          ? axiosError.response.data
          : "Unknown error",
      };
    }
  },
  getDashboardData: async (
    clientId: string,
    taxYear: number,
  ): Promise<any | IServerError | IResponse> => {
    // if (!clientId) return null;
    // if (!taxYear) return null;
    // try {
    //   const response: AxiosResponse = await http.get<any>(
    //     `/v1/dashboard/provinces-menu?client_id=${clientId}&tax_year=${taxYear}&status_code=all`,
    //   );

    //   if (response.status === 200) {
    //     return response.data;
    //   } else if (response.status === 400) {
    //     return {
    //       status: false,
    //       message: "Bad Request.",
    //       error: true,
    //     };
    //   } else if (response.status === 500) {
    //     return {
    //       status: false,
    //       message: "Something went wrong.",
    //       error: true,
    //     };
    //   } else {
    //     return response.data;
    //   }
    // } catch (error) {
    //   const axiosError = error as AxiosError;
    //   console.error("An error occurred:", axiosError);
    //   return {
    //     status: false,
    //     message: axiosError.response
    //       ? axiosError.response.data
    //       : "Unknown error",
    //   };
    // }

    // dashboard design 1
    // const fixedResponse: any = {
    //   header: {
    //     company: {
    //       id: "client-001",
    //       name: "Sterling Manufacturing Inc.",
    //       logoUrl:
    //         "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",
    //     },
    //     asOfDateLabel: "Thursday, June 19, 2026",
    //   },

    //   accountSummary: {
    //     dataStartFromLabel: "Jan 26",
    //     liveFromLabel: "01 Jan 26",
    //     totalEmployees: 54,
    //     activeEmployees: 54,
    //     directDepositEmployees: 0,
    //     chequeEmployees: 54,
    //     adminAccessCount: 0,
    //     employeeAccessCount: 0,
    //   },

    //   upcomingPayrollRuns: {
    //     runs: [
    //       {
    //         id: "run-monthly-3",
    //         frequency: "Monthly",
    //         runNumber: 3,
    //         endingDateLabel: "Mar 31, 2026",
    //         deadlineDateLabel: "Mar 25, 01:00 PM EST",
    //         paymentDateLabel: "Mar 31",
    //         employeeCount: 13,
    //       },
    //       {
    //         id: "run-semi-monthly-1",
    //         frequency: "Semi Monthly",
    //         runNumber: 1,
    //         endingDateLabel: "Jan 15, 2026",
    //         deadlineDateLabel: "Jan 09, 01:00 PM EST",
    //         paymentDateLabel: "Jan 15",
    //         employeeCount: 13,
    //       },
    //       {
    //         id: "run-biweekly-1",
    //         frequency: "Biweekly",
    //         runNumber: 1,
    //         endingDateLabel: "Jan 14, 2026",
    //         deadlineDateLabel: "Jan 08, 01:00 PM EST",
    //         paymentDateLabel: "Jan 14",
    //         employeeCount: 14,
    //       },
    //       {
    //         id: "run-weekly-1",
    //         frequency: "Weekly",
    //         runNumber: 1,
    //         endingDateLabel: "Jan 07, 2026",
    //         deadlineDateLabel: "Jan 01, 01:00 PM EST",
    //         paymentDateLabel: "Jan 07",
    //         employeeCount: 13,
    //       },
    //     ],
    //   },

    //   availableBalance: {
    //     amount: 128450,
    //     currency: "CAD",
    //     accountLabel: "Payroll trust account",
    //   },

    //   notificationsSummary: {
    //     unreadCount: 2,
    //     preview: [
    //       {
    //         id: "notif-1",
    //         message: "CRA remittance due in 12 days",
    //         severity: "warning",
    //         timeAgoLabel: "2 hours ago",
    //       },
    //       {
    //         id: "notif-2",
    //         message: "Banking info missing for 1 employee",
    //         severity: "critical",
    //         timeAgoLabel: "1 day ago",
    //       },
    //     ],
    //   },

    //   payrollProcessing: {
    //     statusLabel: "On track",
    //     statusTone: "success",
    //     payPeriodLabel: "Pay period Sept 16–29, 2026",
    //     payDateLabel: "Pay date Sept 30, 2026",
    //     steps: [
    //       {
    //         key: "hours-submitted",
    //         label: "Hours Submitted",
    //         status: "complete",
    //       },
    //       { key: "approved", label: "Approved", status: "complete" },
    //       { key: "calculated", label: "Calculated", status: "current" },
    //       {
    //         key: "funds-withdrawal",
    //         label: "Funds Withdrawal",
    //         status: "upcoming",
    //       },
    //       { key: "paid", label: "Paid", status: "upcoming" },
    //     ],
    //     employeeCount: 42,
    //     grossPay: 94600.0,
    //     netPay: 71320.0,
    //     currency: "CAD",
    //   },

    //   taxRemittances: {
    //     subtitle: "Upcoming and recent CRA and Revenu Québec payments",
    //     rows: [
    //       {
    //         id: "remit-1",
    //         authority: "Canada Revenue Agency",
    //         description: "Federal & provincial remittance (excl. QC)",
    //         dateLabel: "Due Oct 15, 2026",
    //         amount: 18240.0,
    //         currency: "CAD",
    //         status: "Scheduled",
    //       },
    //       {
    //         id: "remit-2",
    //         authority: "Revenu Québec",
    //         description: "QC provincial tax, QPP & QPIP",
    //         dateLabel: "Due Oct 15, 2026",
    //         amount: 6180.0,
    //         currency: "CAD",
    //         status: "Scheduled",
    //       },
    //       {
    //         id: "remit-3",
    //         authority: "Canada Revenue Agency",
    //         description: "August remittance",
    //         dateLabel: "Paid Sept 15, 2026",
    //         amount: 17960.0,
    //         currency: "CAD",
    //         status: "Submitted",
    //       },
    //     ],
    //   },

    //   directDeposit: {
    //     buckets: [
    //       {
    //         id: "deposit-payroll",
    //         label: "Payroll Deposits",
    //         amount: 86240.0,
    //         currency: "CAD",
    //         statusLabel: "Scheduled",
    //         metaLabel: "42 employees · Sept 30, 2026",
    //       },
    //       {
    //         id: "deposit-tax",
    //         label: "Tax Remittance Deposits",
    //         amount: 24420.0,
    //         currency: "CAD",
    //         statusLabel: "Scheduled",
    //         metaLabel: "CRA + Revenu Québec · Oct 15, 2026",
    //       },
    //     ],
    //     note: "Deposits are processed via Canadian EFT (2 business days).",
    //   },

    //   recordsOfEmployment: {
    //     rows: [
    //       {
    //         id: "roe-1",
    //         employeeName: "Javier Alvarez",
    //         detailLabel: "Issued Sept 12, 2026 · Submitted to Service Canada",
    //         status: "Submitted",
    //       },
    //       {
    //         id: "roe-2",
    //         employeeName: "Maya Chen",
    //         detailLabel:
    //           "Termination Sept 15, 2026 · Due within 5 calendar days",
    //         status: "Action needed",
    //       },
    //     ],
    //   },

    //   yearEndFiling: {
    //     taxYear: 2026,
    //     verifiedEmployees: 40,
    //     totalEmployees: 42,
    //     checklist: [
    //       {
    //         id: "ye-1",
    //         label: "2025 T4 & RL-1 slips — filed Feb 24, 2026",
    //         done: true,
    //       },
    //       {
    //         id: "ye-2",
    //         label: "2026 filing window — opens January 2027 · due Feb 28, 2027",
    //         done: false,
    //       },
    //     ],
    //   },

    //   alerts: {
    //     items: [
    //       {
    //         id: "alert-1",
    //         title: "CRA remittance due in 12 days",
    //         severity: "warning",
    //         timeAgoLabel: "2 hours ago",
    //       },
    //       {
    //         id: "alert-2",
    //         title: "Banking information missing for 1 employee",
    //         severity: "critical",
    //         timeAgoLabel: "1 day ago",
    //       },
    //       {
    //         id: "alert-3",
    //         title: "ROE required for Maya Chen within 5 days",
    //         severity: "warning",
    //         timeAgoLabel: "1 day ago",
    //       },
    //       {
    //         id: "alert-4",
    //         title: "August remittance confirmed received by CRA",
    //         severity: "success",
    //         timeAgoLabel: "3 days ago",
    //       },
    //     ],
    //   },

    //   news: {
    //     items: [
    //       {
    //         id: "news-1",
    //         tag: "CRA",
    //         title: "Payroll remittance guidance updated for the 2027 tax year",
    //         description:
    //           "Review the latest thresholds and due-date changes before your next filing.",
    //         dateLabel: "Sept 15, 2026",
    //       },
    //       {
    //         id: "news-2",
    //         tag: "Revenu Québec",
    //         title: "RL-1 filing portal maintenance window scheduled",
    //         description:
    //           "Online RL-1 submissions may be temporarily unavailable overnight.",
    //         dateLabel: "Sept 10, 2026",
    //       },
    //       {
    //         id: "news-3",
    //         tag: "Payroll",
    //         title: "Statutory holiday pay reminder",
    //         description:
    //           "National Day for Truth and Reconciliation falls within your next pay period.",
    //         dateLabel: "Sept 8, 2026",
    //       },
    //     ],
    //   },

    //   helpGuides: {
    //     quickLinks: [
    //       {
    //         id: "quick-1",
    //         label: "Start here after first login",
    //         href: "/help/getting-started",
    //       },
    //       {
    //         id: "quick-2",
    //         label: "Setup a new account (QC)",
    //         href: "/help/setup-account-qc",
    //       },
    //     ],
    //     guides: [
    //       {
    //         id: "guide-1",
    //         label: "Add a 2nd company bank account",
    //         href: "/help/second-bank-account",
    //       },
    //       {
    //         id: "guide-2",
    //         label: "Manage account on wire transfers only",
    //         href: "/help/wire-transfers-only",
    //       },
    //       {
    //         id: "guide-3",
    //         label: "Bank errors and fees explained",
    //         href: "/help/bank-errors-fees",
    //       },
    //       {
    //         id: "guide-4",
    //         label: "Manage duplicate employees in T4/RL-1 filing",
    //         href: "/help/duplicate-employees",
    //       },
    //       {
    //         id: "guide-5",
    //         label: "Change employee payroll frequency",
    //         href: "/help/change-pay-frequency",
    //       },
    //       {
    //         id: "guide-6",
    //         label: "Payroll Adjustment",
    //         href: "/help/payroll-adjustment",
    //       },
    //       { id: "guide-7", label: "T4 Slip", href: "/help/t4-slip" },
    //       {
    //         id: "guide-8",
    //         label: "Update T4 Slip",
    //         href: "/help/update-t4-slip",
    //       },
    //       {
    //         id: "guide-9",
    //         label: "T4 Summary Filing",
    //         href: "/help/t4-summary-filing",
    //       },
    //       { id: "guide-10", label: "RL-1 Slip", href: "/help/rl1-slip" },
    //       {
    //         id: "guide-11",
    //         label: "Update RL-1 Slip",
    //         href: "/help/update-rl1-slip",
    //       },
    //       { id: "guide-12", label: "RL-1 Filing", href: "/help/rl1-filing" },
    //     ],
    //   },

    //   support: {
    //     phoneNumbers: ["1.877.696.0336", "416.363.2226"],
    //     responseTimeNote: "Our support team responds within one business day.",
    //   },
    // };

    // dashboard design 2
    const fixedResponse: any = {
      header: {
        clients: [
          {
            value: "client-001",
            label: "Sterling Manufacturing Inc.",
            logoUrl: null,
            craBusinessNumber: "CRA · 84521 3392 RP0001",
          },
          {
            value: "client-002",
            label: "Maple Grove Bakery Inc.",
            logoUrl: null,
            craBusinessNumber: "CRA · 84521 3392 RP0001",
          },
          {
            value: "client-003",
            label: "Cascadia Outfitters Inc.",
            logoUrl: null,
            craBusinessNumber: "CRA · 84521 3392 RP0001",
          },
        ],
        selectedClientId: "client-002",
      },

      alertBanners: {
        banners: [
          {
            id: "banner-nsf",
            severity: "error",
            title: "NSF — payroll debit returned",
            description:
              "Sept 19 debit of $41,280.44 was returned. Replenish by 3:00 PM ET today.",
            actionLabel: "Resolve now",
          },
          {
            id: "banner-payday",
            severity: "warning",
            title: "Payday in 2 days",
            description:
              "Current run must be approved by Wed Sept 23, 2:00 PM ET.",
            actionLabel: "Review run",
          },
          {
            id: "banner-remittance",
            severity: "info",
            title: "CRA remittance due Oct 10",
            description:
              "Source deductions of $18,942.11 are scheduled — nothing to do.",
            actionLabel: "View",
          },
        ],
      },

      payrollProcessing: {
        runLabel: "PR-2026-19",
        payPeriodLabel: "Pay period Sep 6 – Sep 19, 2026",
        employeeCount: 24,
        paydayLabel: "Payday Fri, Sep 25, 2026",
        steps: [
          {
            key: "draft",
            label: "Draft",
            status: "complete",
            dateLabel: "Sep 20",
          },
          {
            key: "calculated",
            label: "Calculated",
            status: "complete",
            dateLabel: "Sep 21",
          },
          {
            key: "approved",
            label: "Approved",
            status: "current",
            dateLabel: "Due Sep 21",
          },
          {
            key: "funded",
            label: "Funded",
            status: "upcoming",
            dateLabel: "Sep 24",
          },
          {
            key: "paid",
            label: "Paid",
            status: "upcoming",
            dateLabel: "Sep 25",
          },
          {
            key: "remitted",
            label: "Remitted",
            status: "upcoming",
            dateLabel: "Oct 10",
          },
        ],
        grossPay: 58412.77,
        deductionsAndTaxes: 17132.33,
        netPay: 41280.44,
        currency: "CAD",
      },

      payrollErrors: {
        count: 2,
        errors: [
          {
            id: "error-nsf",
            title: "Payroll debit returned",
            tagLabel: "NSF",
            description:
              "Sep 19 pre-authorized debit of $41,280.44 was returned by RBC (...8842).",
            alert: "Replenish by 3:00 PM ET today to avoid late pay.",
            actionLabel: "Add funds",
          },
          {
            id: "error-deposits-rejected",
            title: "2 direct deposits rejected",
            tagLabel: "EMPLOYEE BANK",
            description:
              "J. Tremblay — invalid transit number · S. Okafor — account closed.",
            alert: "Reissue by cheque or update banking before payday.",
            actionLabel: "Fix banking",
          },
        ],
      },

      payrollClearingAccount: {
        balance: 52310.18,
        currency: "CAD",
        ledgerItems: [
          {
            id: "ledger-payroll-debit",
            label: "Payroll debit · Sep 24",
            amount: -41280.44,
          },
          {
            id: "ledger-cra-remittance",
            label: "CRA remittance · Oct 10",
            amount: -18942.11,
          },
        ],
        projectedLabel: "Projected after Oct 10",
        projectedAmount: -2912.37,
        shortfallNote:
          "Shortfall of $2,912.37 — top up to cover the NSF debit and Oct remittance.",
        ytdGross: 1042318.55,
        ytdRemitted: 332541.09,
      },

      taxRemittances: {
        outstandingTotal: 25101.83,
        currency: "CAD",
        rows: [
          {
            id: "remit-cra-source",
            authority: "CRA source deductions",
            description: "Sep 2026",
            dateLabel: "Due Oct 10, 2026",
            amount: 18942.11,
            currency: "CAD",
            status: "Scheduled",
          },
          {
            id: "remit-eht",
            authority: "Employer Health Tax (EHT)",
            description: "Q3 2026",
            dateLabel: "Due Oct 15, 2026",
            amount: 4286.5,
            currency: "CAD",
            status: "Due soon",
          },
          {
            id: "remit-wsib",
            authority: "WSIB premiums",
            description: "Q3 2026",
            dateLabel: "Due Oct 20, 2026",
            amount: 1873.22,
            currency: "CAD",
            status: "Scheduled",
          },
          {
            id: "remit-cra-source-paid",
            authority: "CRA source deductions",
            description: "Aug 2026",
            dateLabel: "Paid Sep 10",
            amount: 18104.76,
            currency: "CAD",
            status: "Paid",
          },
        ],
      },

      recordsOfEmployment: {
        readyToProcessCount: 2,
        readyToProcess: [
          {
            id: "roe-marc",
            employeeName: "Marc Dubois",
            codeLabel: "Code A — Shortage of work",
            lastDayLabel: "Last day Sep 18, 2026",
            issueWithinLabel: "Issue within 5 calendar days",
            daysLeft: 2,
          },
          {
            id: "roe-priya",
            employeeName: "Priya Nair",
            codeLabel: "Code D — Illness or injury",
            lastDayLabel: "Last day Sep 20, 2026",
            issueWithinLabel: "Issue within 5 calendar days",
            daysLeft: 4,
          },
        ],
        processedBySystem: [
          {
            id: "roe-liam",
            employeeName: "Liam Chen",
            codeLabel: "Code A",
            issuedDateLabel: "Issued Sep 12, 2026",
            roeNumber: "ROE-88412",
          },
          {
            id: "roe-fatima",
            employeeName: "Fatima Ali",
            codeLabel: "Code E",
            issuedDateLabel: "Issued Aug 29, 2026",
            roeNumber: "ROE-88340",
          },
          {
            id: "roe-noah",
            employeeName: "Noah Bergeron",
            codeLabel: "Code A",
            issuedDateLabel: "Issued Aug 15, 2026",
            roeNumber: "ROE-88277",
          },
        ],
      },

      yearEndCompliance: {
        taxYear: 2026,
        percentComplete: 58,
        dueDateLabel: "T4s due Mar 1, 2027",
        checklist: [
          {
            id: "ye-sin",
            label: "Verify employee SINs & addresses",
            done: true,
          },
          {
            id: "ye-reconcile",
            label: "Reconcile CRA remittances vs. ledger",
            done: true,
          },
          {
            id: "ye-benefits",
            label: "Confirm taxable benefits (RRSP, vehicles)",
            done: false,
          },
          {
            id: "ye-eht",
            label: "Review EHT annual reconciliation",
            done: false,
          },
          {
            id: "ye-t4",
            label: "T4 slips & summary",
            done: false,
            automated: true,
          },
        ],
      },

      news: {
        items: [
          {
            id: "news-1",
            tag: "CRA",
            title: "CRA opens 2026 T4 filing season — new XML schema mandatory",
            dateLabel: "Sep 18, 2026",
          },
          {
            id: "news-2",
            tag: "ONTARIO",
            title:
              "Ontario minimum wage rises to $17.60/hr on Oct 1 — 6 employees affected",
            dateLabel: "Sep 15, 2026",
          },
          {
            id: "news-3",
            tag: "EI",
            title:
              "EI premium rate confirmed at 1.64% for 2027 (employee portion)",
            dateLabel: "Sep 8, 2026",
            href: "/news/ei-premium-rate-2027",
          },
        ],
      },

      // ===== CHANGED: added `kind` per resource so the icon matches its type (copy this block) =====
      helpGuides: {
        resources: [
          {
            id: "guide-approve-run",
            label: "Approving a payroll run",
            metaLabel: "Video · 3 min",
            href: "/help/approving-a-run",
            kind: "video",
          },
          {
            id: "guide-nsf",
            label: "Fixing NSF and rejected deposits",
            metaLabel: "Guide · 5 min read",
            href: "/help/nsf-rejected-deposits",
            kind: "guide",
          },
          {
            id: "guide-roe",
            label: "Issuing an ROE in SimplePay",
            metaLabel: "Guide · 4 min read",
            href: "/help/issuing-roe",
            kind: "guide",
          },
          {
            id: "guide-year-end",
            label: "Year-end checklist 2026",
            metaLabel: "Checklist",
            href: "/help/year-end-checklist-2026",
            kind: "checklist",
          },
        ],
        ctaTitle: "New to Canadian payroll?",
        ctaDescription:
          "Take the 10-minute guided tour — from your first hire to your first CRA remittance.",
        ctaButtonLabel: "Start tour",
      },

      support: {
        phoneNumbers: ["1.877.696.0336", "416.363.2226"],
        responseTimeNote: "Our support team responds within one business day.",
        chatTitle: "Live chat — SimplePay Support",
        chatStatusLabel: "Online · replies in ~2 min",
        initialMessages: [
          {
            id: "msg-1",
            sender: "agent",
            senderLabel: "Sam (SimplePay)",
            text: "Hi Aisha — I see the Sep 19 debit came back NSF. Want me to walk you through re-funding it?",
            timeLabel: "9:14 AM",
          },
          {
            id: "msg-2",
            sender: "user",
            text: "Yes please. Can I wire the funds today?",
            timeLabel: "9:15 AM",
          },
          {
            id: "msg-3",
            sender: "agent",
            senderLabel: "Sam (SimplePay)",
            text: "Absolutely — wire by 3:00 PM ET and we can still hit the Sep 25 pay date. Sending the instructions now.",
            timeLabel: "9:15 AM",
          },
        ],
      },
    };

    return new Promise((resolve) =>
      setTimeout(() => resolve(fixedResponse), 1000),
    );
  },
  getAllCounts: async (
    clientId: string,
    taxYear: number,
  ): Promise<any | IServerError | IResponse> => {
    try {
      const response: AxiosResponse = await http.get<any>(
        `/v1/dashboard-api/?client_id=${clientId}&tax_year=${taxYear}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      } else {
        return response.data;
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      return {
        status: false,
        message: axiosError.response
          ? axiosError.response.data
          : "Unknown error",
      };
    }
  },
};
